// Username (adrian12@gmail.com => adrian12)
export function getUsername(userEmail) {
  return userEmail.split("@")[0];
}
